import _ from 'lodash';
import Store from './Store';

import Template from './Template';
import DraftSession from './DraftSession';


import mockCardsList from '../pages/__mocks__/cardsList.json';
import mockTemplates from '../containers/__mocks__/templates.json';

export default class DraftSessions extends Store {

  store = {
    next: null, 
    current: null, 
    completed: [], 
    remaining: []
  }

  defaultKeys = ["next", "current", "completed", "remaining"]

  constructor(props) {
    super(props);
    return this.setup(props);
  }

  static mock({type} = {type: "start"}) {
    const draftTemplate = Template.mock();
    
    if (type === 'end') {
      return {
        current: _.head(draftTemplate.sessions), 
        next: _.nth(draftTemplate.sessions, 1),
        completed: [],
        remaining: _.slice(draftTemplate.sessions, 1)
      }
    }

    if (type === 'completed') {
      return {
        current: null, 
        next: null, 
        completed: draftTemplate.sessions, 
        remaining: []
      }
    }
    
    return {
      current: {}, 
      next: _.head(draftTemplate.sessions),
      completed: [],
      remaining: _.slice(draftTemplate.sessions, 1)
    }
  }

  static mockState({type} = { type: "start" }) {
    const draftTemplate = Template.mock();
    const draftSessionTemplate = _.head(draftTemplate.sessions);

    if (type === 'end') {
      return {
        current: _.head(draftTemplate.sessions), 
        next: _.nth(draftTemplate.sessions, 1),
        completed: [],
        remaining: _.slice(draftTemplate.sessions, 1)
      }
    }

    return {
      current: {}, 
      next: _.head(draftTemplate.sessions),
      completed: [],
      remaining: _.slice(draftTemplate.sessions, 1)
    }
  }
}


// WEBPACK FOOTER //
// ./src/models/DraftSessions.js